<sc-flex [vertical]="true" [stretchContent]="true">
    <sc-dialog-title>
        {{ 'Berechnungsregeln' | translate: ['erp.ui.articletype-calculationrule-editor.title', translationService.language]}}
    </sc-dialog-title>
    <sc-separator-line></sc-separator-line>
    <sc-padding>
        <form [formGroup]="formGroup" class="no-field-space">
            <sc-flex [vertical]="true" [stretchContent]="true">
                <sc-dictionary-field class="input-title" [model]="calculationRuleAttribute?.name" [maxlength]="255"
                    [required]="true" [defaultLabel]="'name'" labelDictionaryKey="erp.entity.calculationrule.name"
                    (dictionaryChanged)="onNameChanged($event)">
                </sc-dictionary-field>
                <sc-content-spacer [vertical]="true"></sc-content-spacer>
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'Präzision' | translate: ['erp.entity.calculationrule.precission', translationService.language]}}</mat-label>
                    <mat-select formControlName="precission" required="true">
                        <mat-option *ngFor="let value of precissions" [value]="value">
                            {{ value }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <sc-content-spacer [vertical]="true"></sc-content-spacer>
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'Attribut' | translate: ['erp.entity.calculationrule.attribute', translationService.language]}}</mat-label>
                    <mat-select formControlName="attributeSelection">
                        <mat-option *ngFor="let value of getAttributesForSelection()" [value]="value.id">
                            <app-dictionary-entry-label [model]="value.name"></app-dictionary-entry-label>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <sc-content-spacer [vertical]="true"></sc-content-spacer>
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'Methode' | translate: ['erp.entity.calculationrule.method', translationService.language]}}</mat-label>
                    <mat-select formControlName="method" required="true">
                        <mat-option *ngFor="let value of methods" [value]="value">
                            {{ value }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <sc-content-spacer [vertical]="true"></sc-content-spacer>
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'Sort Value' | translate: ['erp.entity.calculationrule.sort-order', translationService.language]}}</mat-label>
                    <input matInput formControlName="sortValue">
                </mat-form-field>
            </sc-flex>
        </form>
    </sc-padding>
    <sc-separator-line></sc-separator-line>
    <sc-actionbar>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button (click)="onClose()">
          {{ 'Abbrechen' | translate: ['erp.ui.articletype-calculationrule-editor.action.cancel', translationService.language]}}
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled">
          {{ 'Übernehmen' | translate: ['erp.ui.articletype-calculationrule-editor.action.confirm', translationService.language]}}
        </button>
    </sc-actionbar>
</sc-flex>
